import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URLS } from '../config/api-urls';
import { environment } from '../../../environments/environment';

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const originalUrl = req.url;

    // Si l'url contient déjà http ou https on ne touche pas.
    if (originalUrl.startsWith('http')) {
      return next.handle(req);
    }

    const resolvedUrl = this.resolveUrl(originalUrl);

    const newReq = req.clone({
      url: resolvedUrl
    });

    return next.handle(newReq);
  }

  private resolveUrl(url: string): string {
    const prefixes = ['customer:', 'inventory:', 'drinks:', 'order:', 'payment:', 'staff:', 'analytics:', 'qr:', 'gateway:', 'rating:', 'notification:', 'livechat:'];
    const matched = prefixes.find(p => url.startsWith(p));

    if (matched) {
      return API_URLS.GATEWAY + url.replace(matched, '');
    }

    if (!environment.production) {
      console.warn('[BaseUrlInterceptor] No baseURL matched for:', url);
    }
    return url;
  }
}
